<template>

	<div class="flag-map-container">

		<img
			v-if="this.$store.getters.getAllImages"
			contain
			:src="getFlagMapImage"
			width="800"
			class="flag-map"
		>

		<v-content
			v-for="index in 4"
			:key="index"
			class="d-flex flex-row"
		>

			<QuestionCard
        v-if="isCurrentIndex(index)"
				class="elevation-14"
				style="position: absolute"
				:class="questionCardClasses(index)"
				:content="currentQuestion"
        :color="'green'"
				:doneCheckingFlag="flagCheckComplete"
				:flagError="flagError"
				:index="index - 1"
				:successMsg="successMessage"
				:errorMsg="errorMessage"
				:hints="hints"
				:task="currentTask"
				:clearFlag="clearFlag"
				@dismiss-question-card="dismissQuestionCard()"
				@verify-flag="verifyFlag"
			>
			</QuestionCard>

			<img v-if="!isSolved(transformIndex(index) - 1)"
				style="{ position: absolute; }"
				:class="pointAndWobbleClass(index)"
				:src="getImageForAComponent(index, 'flags')"
				width="64"
				color="red"
				@click.stop="showQuestion(index)"
				@mouseover="hoveredIndex = index"
				@mouseout="hoveredIndex = -1"
			>
			<img v-if="isSolved(transformIndex(index) - 1) && !allFlagsSolved"
				:class="trophyClass(index)"
				:width="increaseSize(index) ? '81' : '64'"
				:src="getImageForAComponent(index, 'trophy')"
				@click="showQuestion(index)"
				@mouseover="hoveredIndex = index"
				@mouseout="hoveredIndex = -1"
			>
		</v-content>

		<v-icon
			v-if="allFlagsSolved && showReloadChallengeIcon"
			size="100"
			dark
			class="replay"
			color="#66BB6A"
			@click="resetChallengeState()"
		>
			mdi-replay
		</v-icon>

	</div>

</template>

<script>

import QuestionCard from "@/components/QuestionCard.vue";

export default {
  name: "FlagMap",
  components: {
  	QuestionCard
  },
  data() {
  	return {
  		flagMarkerIndex: -1,
  		currentIndex: -1,
  		currentQuestion: null,
      currentTask: null,
  		successMsg: "",
  		doneCheckingFlag: null,
  		flagError: false,
  		hoveredIndex: -1,
  		error: "",
  		hints: [],
  		showReloadChallengeIcon: false,
  		clearFlag: false,
  		verifyingFlag: false,
  	};
  },
  created() {
  	// this.pullAllFlagMapImages();
  },
  mounted() {
  	if (this.allFlagsSolved) {
  		this.startConfetti();
  	}
  },
  watch: {
    allFlagsSolved(data) {
      if (data) {
        this.$store.dispatch("setLevel", (this.$store.getters.getLevel + 1));
        this.startConfetti();
      }
    }
  },
  methods: {
    clearFlagState() {

      this.clearFlag = true;
      setTimeout(() => this.clearFlag = false, 1);

    },
  	pullAllFlagMapImages() {

  		let flagMapImages = this.$store.getters.getAllImages["treasure-map"];

  		for (var idx in flagMapImages) {
			this.$axios.get(flagMapImages[idx]);
  		}
  	},
  	resetChallengeState() {

  		this.error = "";

      /*
  		if (!this.$store.getters.isLabStarted) {
  			this.$store.dispatch("resetState");
  		}
      */

  		this.$store.dispatch("resetCTFState");
  		this.stopConfetti();
  		this.showReloadChallengeIcon = false;

      this.clearFlagState();
  	},
  	makeFlagCheckChanges() {

  		this.doneCheckingFlag = null;
  		this.flagDisabled = false;

  	},
  	getImageForAComponent(index, component) {

  		/* eslint-disable no-console */
  		//console.log(newIndex);
  		/* eslint-enable no-console */

		return this.$store.getters.getAllImages[component][this.transformIndex(index) - 1];

  	},
  	transformIndex(index) {

  		let correctIndex = 0;

  		if (index == 1) {
  			correctIndex = 4;
  		}
  		else {
  			correctIndex = index - 1;
  		}

  		return correctIndex;
  	},
  	showQuestion(index) {

  		this.successMsg = "";
  		this.error = "";
  		this.flagError = false;

  		this.flagMarkerIndex = index;
  		this.currentIndex = this.transformIndex(index) - 1;

      this.clearFlagState();

      let questions = this.$store.getters.getQuestionsList[this.currentIndex];

  		this.currentQuestion = questions["question"];
  		this.currentTask = "Task " + (this.currentIndex + 1) + ": " + questions["task"];
  		this.hints = questions["hints"];

  		/* eslint-disable no-console */
  		//console.log("Flag Marker Index: " + this.flagMarkerIndex);
  		//console.log("Current Index: " + this.currentIndex);
  		//console.log("Current Question: " + this.currentQuestion);
  		/* eslint-enable no-console */

  		// alert("Question " + q);
  		this.makeFlagCheckChanges();
  	},
  	verifyFlag(flag) {

  		this.error = "";
  		this.flagError = false;
  		this.doneCheckingFlag = true; // This avoids the show card class!

  		if (this.$store.getters.getSolvedQuestionsList.includes(this.currentIndex)) {
  			return;
  		}

  		if (this.currentIndex > 0 && !this.$store.getters.getSolvedQuestionsList.includes(this.currentIndex - 1)) {
  			//this.flagError = false;
  			this.error = "Please solve the previous flags to unlock this one!";
  			setTimeout(() => this.flagError = true, 3);
  			return;
  		}

  		if (flag == null || flag === "") {
  			this.error = "Empty flag not allowed!";
  			setTimeout(() => this.flagError = true, 1);
  			return;
  		}

      if (this.verifyingFlag) {
        return;
      }

      this.verifyingFlag = true;

      this.doneCheckingFlag = false;
      this.flagError = false;

  		this.$axios
	   	.get("/verify?ques=" + String(this.currentIndex + 1) + "&flag=" + flag)
  			.then(response => {

    			this.doneCheckingFlag = true;

    			if ("error" in response.data) {
    				this.error = response.data["error"];
    				this.flagError = true;
    			}
    			else if ("status" in response.data) {

    				if (response.data["status"] === "fail") {
    					this.flagError = true;
    					this.error = "Incorrect Flag!";
    				}
    				else {
    					this.successMsg = "Correct!"
    					this.flagError = false;

              let solvedQuestionIndex = parseInt(response.data["status"], 10) - 1;

    					if (!this.isSolved(solvedQuestionIndex)) {

    						this.$store.dispatch("addToFlags", { "flag": flag, "index": solvedQuestionIndex });
    						this.$store.dispatch("addToSolvedQuestion", solvedQuestionIndex);

    						this.$store.dispatch("setLevel", (this.$store.getters.getLevel + 1));

    						setTimeout(() => {
                  this.dismissQuestionCard();
                }, 2500);
  				  	}
  				  }
          }
        })
        .catch(error => {
    		  /* eslint-disable no-console */
    			console.log(error);
    			this.error = error;
    			/* eslint-enable no-console */
        })
        .finally(() => {
        	/* eslint-disable no-console */
        	//console.log("Finally!")
          this.verifyingFlag = false;
        	/* eslint-enable no-console */
        });

    },
  	dismissQuestionCard() {

  		this.makeFlagCheckChanges();
  		this.flagError = false;
  		this.flagMarkerIndex = -1;

  	},
  	trophyClass(index) {

  		setTimeout(() => {}, 300);
  		return "trophy-" + index + " point-" + index;

  	},
  	startConfetti() {

  		this.$confetti.start({
			particles: [
				{
					type: 'circle',
					colors: [
						'DodgerBlue',
						'OliveDrab',
						'Gold',
						'pink',
						'SlateBlue',
						'lightblue',
						'Violet',
						'PaleGreen',
						'SteelBlue',
						'SandyBrown',
						'Chocolate',
						'Crimson',
					],
				},
			],
			defaultDropRate: 10,
			defaultSize: 10,
		});

      setTimeout(() => {
        this.showReloadChallengeIcon = true;
      }, 7000)

      // Call stopConfetti after 14 seconds!

      setTimeout(() => {
  			this.stopConfetti();
  		}, 14000);
  	},
  	stopConfetti() {
  		this.$confetti.stop();
  	}
  },
  computed: {

  	allFlagsSolved() {

  		if (this.$store.getters.getSolvedQuestionsList && this.$store.getters.getQuestionsList) {
  			return this.$store.getters.getSolvedQuestionsList.length === this.$store.getters.getQuestionsList.length;
  		}

  		return false;
  	},
  	isCurrentIndex() {
  		return (index) => this.transformIndex(this.flagMarkerIndex) === index;
  	},
  	isSolved() {
  		return (index) => this.$store.getters.getSolvedQuestionsList.includes(index);
  	},
  	flagCheckComplete() {
  		return this.doneCheckingFlag;
  	},
  	increaseSize() {
  		return (index) => this.isSolved(this.transformIndex(index) - 1) || this.hoveredIndex === index;
  	},
  	pointAndWobbleClass() {
  		return (index) => "point-" + index + (this.isSolved(this.transformIndex(index) - 1) ?  "" : (" wobble-" + index));
  	},
  	questionCardClasses() {

		// Warning: Best code ahead!
		// The best thing is the doneCheckingFlag variable
		// It can assume 3 values: true, false and null!

		return (index) => ("question-card-" + index) + (this.flagError ? (" wobble-card-" + index) : (this.doneCheckingFlag !== null) ? "" : " show-question-card-" + index);
  	},
  	getFlagMapImage() {

  		let flagMapImages = this.$store.getters.getAllImages["treasure-map"];
  		return flagMapImages[this.$store.getters.getLevel];

  	},
  	errorMessage() {
  		return this.error;
  	},
  	successMessage() {
  		return this.successMsg;
  	}
  }
};

</script>

<style>
/*
@import "../../public/css/style.css";
@import "../../public/css/marker-positions.css";
@import "../../public/css/animations.css";
*/
</style>